import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import * as imagesProject from "../../assets/exportImages";

const Project = ({ project }) => {
  const { t } = useTranslation();
  
  return (
    <div className="grid__application" key={project.name}>
      <h2 className="description-aplication">{project.name}</h2>
      <div className="single-project">
        <img
          className="project-img"
          src={imagesProject[project.img]}
          alt={`${project.name}`}
        />
        <div className="project-info">
          <div className="slide">
            <div className="info-text">{project.desc}</div>
            <div className="info-button">
              <NavLink to={`/project/${project.route}`}>
                <button className="button-left" type="button">
                  {t("projectDescription.details")}
                </button>
              </NavLink>
              {project.live && (
                <a href={project.live}>
                  <button className="button-right" type="button">
                    {t("projectDescription.live")}
                  </button>
                </a>
              )}
            </div>
          </div>
          <div className="anime-image-top"></div>
          <div className="anime-image2-top"></div>
          <div className="anime-image-bottom"></div>
          <div className="anime-image2-bottom"></div>
        </div>
      </div>
    </div>
  );
};

export default Project;
